"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupVideoElement = void 0;
const common_1 = require("../device/common");
function setupVideoElement() {
    const videoElement = document.createElement("video");
    videoElement.setAttribute("playsinline", "");
    if ((0, common_1.getBrowser)() === "firefox") {
        videoElement.setAttribute("preload", "auto");
    }
    return videoElement;
}
exports.setupVideoElement = setupVideoElement;
//# sourceMappingURL=dom.js.map